module.exports = __webpack_public_path__ + "img/zhjhhhx.451382ae.png";